var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCompany48Filled = function SvgIconCompany48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 20.3h-2.7v-5.7a5.3 5.3 0 0 0-5.3-5.3H14.6a5.3 5.3 0 0 0-5.3 5.3v18.8a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3v-7.8a5.3 5.3 0 0 0-5.3-5.3Zm-11.7 15h-3.4V30h3.4v5.3Zm1.8-9.6h-7v-3.4h7v3.4Zm0-6.5h-7v-3.4h7v3.4Zm11.8 14.2a1.9 1.9 0 0 1-1.9 1.9h-2.7V23.7h2.7a1.9 1.9 0 0 1 1.9 1.9v7.8Z",
    fill: "current"
  })));
};
export default SvgIconCompany48Filled;